/**
 * Block is used on
 *
 * @returns {{init(): void, loadMore(): void, liveInCareAvailable: boolean, sort(*): void, loading: boolean, initMap(): void, visibleResults: [], hiddenResults: [], activeIndex: null, search(): void, careService: number, sortType: number, viewType: string, location: string, locations: [], changeView(*): void, results: [], open: boolean, selected: null}}
 */
export default () => ({
    mapModalOpen: false,
    mapModalQuery: ''
})